import React from "react";
import { Box, Flex, Link, useTheme } from "@chakra-ui/react";
import { ManagerWhiteLabelMenuProps } from "./ManagerWhiteLabelMenu.types";
import { Link as RouterLink } from "react-router-dom";
import {
  buildRouteUrl,
  Button,
  managerWhiteLabelSectionParams,
  openUrlInNewWindow,
  SwimRingIcon,
} from "@verivest/shared-components";
import { useParams } from "react-router";
import { managerWhiteLabelMenuItems } from "../../../../data/menu";
import { ManagerWhiteLabelRouteParams } from "../../../../routes/investorPortalPages.types";
import { cn } from "@verivest/shared-components/src/utils/css";
import { useInvestorPortal } from "../../InvestorPortalContext";

export const ManagerWhiteLabelMenu: React.FC<ManagerWhiteLabelMenuProps> = ({
  manager,
  ...rest
}) => {
  const { isMobileMenuOpen, setIsMobileMenuOpen } = useInvestorPortal();
  const theme = useTheme();
  //const headerHeight = useGetHeaderHeight();

  //const isFixedNav = useBooleanState(false);

  const refs = React.useRef<
    { section: string; el: HTMLAnchorElement | null }[]
  >([]);
  const menuPlaceholderRef = React.useRef<HTMLDivElement>(null);
  const menuRef = React.useRef<HTMLDivElement>(null);

  const setIsMobileOpen = (isOpen: boolean) => {
    const rootEl = document.body as HTMLElement;
    if (rootEl) {
      if (isOpen) rootEl.classList.add("tw:overflow-hidden", "h-screen");
      else rootEl.classList.remove("tw:overflow-hidden", "h-screen");
    }
    setIsMobileMenuOpen(isOpen);
  };

  const { [managerWhiteLabelSectionParams.section]: selectedMenu } =
    useParams<ManagerWhiteLabelRouteParams>();

  /*React.useEffect(() => {
    const onScroll = () => {
      if (menuPlaceholderRef.current) {
        const headerRef = window.document.getElementById("ip3-header-base");
        const { top } = menuPlaceholderRef.current.getBoundingClientRect();
        if (top - headerHeight - 12 < 0) {
          headerRef?.classList.add("sub-menu-fixed");
          menuPlaceholderRef.current.style.height = `${menuRef.current?.clientHeight}px`;
          isFixedNav.true();
        } else {
          headerRef?.classList.remove("sub-menu-fixed");
          isFixedNav.false();
          menuPlaceholderRef.current.style.height = "0";
        }
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [menuPlaceholderRef.current, menuRef.current, isFixedNav.state]);*/

  const goToHelpAndSupport = () => {
    openUrlInNewWindow("https://support.verivest.com");
  };

  return (
    <>
      <Box ref={menuPlaceholderRef} {...rest}></Box>
      <Box
        mt={"89px"}
        ref={menuRef}
        borderBottom={"1px solid"}
        borderColor={"#E9E9E9"}
        /*{...(isFixedNav.state
          ? {
              pos: "fixed",
              left: 0,
              right: 0,
              top: headerHeight - 2,
              backgroundColor: "rgba(255,255,255,1)",
              display: "flex",
              justifyContent: "center",
              my: 0,
              pt: 2.5,
              zIndex: "docked",
              boxShadow: 3,
              transition:
                "box-shadow 0.6s ease-in, background-color 0.15s ease-in",
            }
          : undefined)}*/
        className={cn(
          "backdrop-blur-lg p-10 overflow-auto bg-white/80 inset-0 fixed z-[999999] sm:animate-none sm:z-auto sm:bg-transparent sm:relative sm:block sm:overflow-visible sm:p-0",
          isMobileMenuOpen
            ? "block animate-slide-in-right"
            : "hidden animate-slide-out-left",
        )}
      >
        <Flex
          {...theme?.investorPortal?.fixed}
          className={"flex-col gap-4 w-full sm:gap-16 md:flex-row"}
        >
          {managerWhiteLabelMenuItems.map((item, itemIndex) => (
            <Link
              as={RouterLink}
              _hover={{ textDecoration: "none" }}
              to={buildRouteUrl(item.url, {
                managerId: manager.slug || String(manager.id) || "",
              })}
              onClick={() => {
                setIsMobileOpen(false);
              }}
              key={itemIndex}
              ref={(el) =>
                (refs.current = [
                  ...refs.current,
                  { section: item.sectionName, el },
                ])
              }
              borderLeftColor={"brand.main"}
              color={selectedMenu === item.sectionName ? "brand.main" : "ink"}
              pos={"relative"}
              className={
                selectedMenu === item.sectionName
                  ? "border-l-4 p-3 rounded-sm sm:border-l-0 sm:p-0 sm:pb-5 sm:rounded-node"
                  : "p-3 sm:p-0 sm:pb-5"
              }
            >
              {item.label}
              {selectedMenu === item.sectionName && (
                <Box
                  className={"hidden sm:block"}
                  left={0}
                  w={"100%"}
                  as={"span"}
                  pos={"absolute"}
                  h={"4px"}
                  bg={"brand.main"}
                  borderRadius={4}
                  bottom={"-2px"}
                  transition={"width 0.6s ease, left 0.6s ease"}
                ></Box>
              )}
            </Link>
          ))}
          <Box className={"flex sm:hidden justify-between items-center"}>
            {/*<ManagerIcon />
            <IconButton onClick={() => setIsMobileOpen(false)} isGhost>
              <CloseIcon boxSize={6} />
            </IconButton>*/}
            <Box>
              <Button
                onClick={goToHelpAndSupport}
                px={3}
                py={2}
                borderRadius={"27px"}
                border={"1px solid #e3e3e3"}
                alignItems={"center"}
                leftIcon={SwimRingIcon}
                leftIconProps={{ boxSize: 6, color: "ink" }}
                bg={"white"}
                textProps={{
                  color: "ink",
                  textStyle: "bodyRegular",
                  fontWeight: "normal",
                  alignItems: "center",
                }}
                empty
              >
                Help & Support
              </Button>
            </Box>
          </Box>
        </Flex>
      </Box>
    </>
  );
};
